import {
  FETCH_WALLET_TOP_UP_OFFERS,
  SAVE_WALLET_TOP_UP_OFFERS,
  DELETE_WALLET_TOP_UP_OFFER,
  FETCH_WALLET_TOP_UP_OFFER_HISTORY,
} from 'actions/walletTopUpOffer';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  walletTopUpOffers: [],
  walletTopUpOfferHistory: [],
};

const walletTopUpOfferReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_WALLET_TOP_UP_OFFERS.REQUEST:
    case SAVE_WALLET_TOP_UP_OFFERS.REQUEST:
    case DELETE_WALLET_TOP_UP_OFFER.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_WALLET_TOP_UP_OFFERS.SUCCESS:
    case SAVE_WALLET_TOP_UP_OFFERS.SUCCESS: {
      type === SAVE_WALLET_TOP_UP_OFFERS.SUCCESS && toast.success('Top-up offers saved successfully');
      return { ...state, isLoading: false, walletTopUpOffers: Array.isArray(payload) ? payload : [] };
    }

    case FETCH_WALLET_TOP_UP_OFFER_HISTORY.SUCCESS: {
      return { ...state, walletTopUpOfferHistory: Array.isArray(payload) ? payload : [] };
    }

    case DELETE_WALLET_TOP_UP_OFFER.SUCCESS: {
      toast.success('Top-up offer archived successfully');
      return { ...state, isLoading: false };
    }

    case FETCH_WALLET_TOP_UP_OFFERS.FAIL:
    case SAVE_WALLET_TOP_UP_OFFERS.FAIL:
    case DELETE_WALLET_TOP_UP_OFFER.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return state;
  }
};

export default walletTopUpOfferReducer;
